export const testimonials = [
  {
    name: "Dr. Isabella Vega",
    role: "Orthodontist",
    location: "Bogotá, Colombia",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/23ea1b31-07ab-46fd-bcc6-562453fcdd4d.jpg",
    headline: "The biomechanics explanations are exactly what I was looking for.",
    quote: "I wanted a more organized way to study self-ligating systems. Having the principles, illustrations, and clinical considerations together makes reviewing the subject much easier.",
  },
  {
    name: "Dr. Andrés Villalobos",
    role: "Orthodontist",
    location: "Monterrey, Mexico",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a366ff9a-7732-4f54-bf06-ccae399ea55f.jpg",
    headline: "Finally, a resource focused on the clinical reasoning behind the brackets.",
    quote: "What I value most is understanding why different mechanical approaches are considered, rather than simply memorizing appliance sequences.",
  },
  {
    name: "Dr. Lucía Fernández",
    role: "Postgraduate Orthodontic Resident",
    location: "Madrid, Spain",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/3f951ea0-5b27-4767-a614-503ea28b1e13.jpg",
    headline: "The archwire reference tables are extremely useful.",
    quote: "Being able to compare mechanical properties and review the principles in one place is exactly the kind of resource I look for when studying orthodontics.",
  },
  {
    name: "Dr. Robert Hayes",
    role: "General Dentist",
    location: "Austin, USA",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/2292b0ca-4df1-49c2-ba17-abc0459adf1e.jpg",
    headline: "I like the connection between diagnosis and biomechanics.",
    quote: "Orthodontic concepts make much more sense when they're presented as parts of a complete planning process. That's what this collection does.",
  },
  {
    name: "Dr. Valentina Cruz",
    role: "Orthodontist",
    location: "Santiago, Chile",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/53e46c7e-5120-4b9b-ac37-fe1b7f62e84d.jpg",
    headline: "The visual casebook is the feature that caught my attention.",
    quote: "The scenarios connecting movement objectives, anchorage, and biomechanics help me review the subject in a far more practical way.",
  },
  {
    name: "Dr. Mateo Vargas",
    role: "Orthodontist",
    location: "Lima, Peru",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/60b78367-fe3a-4623-8bee-3883d9abf2d9.jpg",
    headline: "The one-page planning template is now part of my case discussions.",
    quote: "It helps me lay out objectives, anchorage, and treatment phases before I even think about the appliance. Simple, visual, and easy to come back to.",
  },
];
